var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentLinkAja(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1134.43 1134.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e92629;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Link Aja 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1027.89,1134.42H106.45C47.94,1134.42,0,1086.49,0,1027.88V106.54C0,47.93,47.94,0,106.45,0h921.44c58.6,0,106.54,47.93,106.54,106.54v921.34c0,58.61-47.94,106.54-106.54,106.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M780.37,688.8h38.06l4.54-5.86,30.51-148s1.24-7.64-8.36-7.38H795.67l-7.38,6.14L775,683.11l5.42,5.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.73,213.6h53.71l6.68,7.66-25,173.15,11,12.63h94.27l4.35,5.07-7.38,49.7-5.15,4.54H270.61c-31.76,0-62.16-26.05-57.64-57.45l25.09-189.42,6.67-5.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "423.96 282.7 399.33 459.32 403.95 464.56 455.97 464.56 463.36 458.16 487.72 284.47 481.05 276.92 430.54 276.92 423.96 282.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M531.23,451.06c-16-.62-23.57,4.45-33,10.14,2.22-15.93,20.19-140.08,21.79-147.63,1.77-8.19,3.28-21.71,10.49-28.56,8.36-8,21.34-12.62,85.82-12.8,65.82-.27,78.53,47.14,75.07,77.91-2.94,26.41-12.73,91.51-15.57,109.65l-5.51,4.8H619.44l-6-6.93c2.57-18.23,9.43-66.7,11.82-80.75,2.85-17.44,5.17-36.64.54-44.21s-18.58-13.33-45.27-8.7L560.66,463.77S548,451.68,531.23,451.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "746.58 203.58 802.95 203.58 806.43 207.49 771.3 461.85 767.56 465.14 711.81 465.14 708.07 460.77 743.11 206.61 746.58 203.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "790.23 356.81 854 282.1 862 278.46 918.03 278.46 921.5 286.2 856.31 358.58 915.9 486.74 909.41 496.78 858.88 496.78 852.66 492.87 790.23 356.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M498.59,229.13c-4.53,19.2-21.88,33.52-40,33.52s-32.1-15.56-27.48-34.77S450.65,193,472.17,193c18.15,0,30.95,16.89,26.42,36.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M555.94,509.61c-4.54,19.21-21.89,33.53-40,33.53s-32.1-15.57-27.48-34.77,19.57-34.86,41.08-34.86c18.15,0,31,16.89,26.43,36.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M828.8,739.54c-3.83,19-21.34,33.18-40.46,33.18s-34.42-15.48-30.59-34.51,18.85-34.41,41.52-34.33c19,0,33.35,16.63,29.53,35.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M431.33,739.56,393.27,511.44a20.72,20.72,0,0,0-20.45-17.25H334.58a29.59,29.59,0,0,0-27,17.43L204.83,739.91l4.63,7,53.34-.36,8.37-5.6,17.7-41.71,2.84-1.87h64.56l3,2.85,3.91,39.39,8.89,8.19h52.3l6.93-8.27m-82.7-94.72H314.48l-1.7-2.49,29.72-75.42,2.84.45L352,641.1l-3.38,3.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M405.92,780.91,418.28,819l8.19,6.76c15.55-3.29,53.17-14.41,71.58-39.31,23.93-32.46,27.22-89.82,31.48-119,3.48-24,11.12-83.06,13.7-103.17l-6-6.84H489.43l-8.37,7.29c-3.91,28.36-17.78,130.47-20.18,144.6-2.84,16.46-3.39,40.2-27.75,54.35-12.18,7-18.41,8.35-23.21,10.58l-4,6.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M738.1,564.26c-16.1-4-43.23-12.89-86.8-9.69-40.19,2.93-85.64,21.52-94.09,100.93s27.74,94.63,79.95,96.94a190.09,190.09,0,0,0,81.55-14.59l8.53-11.29,19.22-152.79-8.36-9.51M669.09,693s-24.91,8.45-36.91-.54-13-27.39-6-53.8,24.46-31,31.93-31.48l21.52,3.12Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "775.34 678.52 789.38 532.14 799.52 524.76 848 524.76 853.15 533.83 823.54 680.39 817.58 685.2 781.47 685.2 775.34 678.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.8,948.39a44.12,44.12,0,0,0,31.49,4.36c42.42-10.13,136.42-37.18,335.1-65.9,249.72-36.11,434.08-35.92,434.08-35.92l.53-.36s-163.46-22.42-431.59,3.73-417.89,67.41-417.89,67.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLinkAja);
export default __webpack_public_path__ + "static/media/payment_link_aja.db5018b94c58d0914a512b0efb37f117.svg";
export { ForwardRef as ReactComponent };